var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-select-field',{attrs:{"items":_vm.intervals,"label":_vm.label || _vm.$t('common.period'),"item-text":"text","item-value":"value"},model:{value:(_vm.value),callback:function ($$v, $$p) {_vm.$updateField([], $$v, undefined)},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }